import instance from "../../services/axios";

const uri = {
  hotelCountrySearchList: "/hotel/get-city",
  hotelCheckinCheckoutResult: "/hotel/hotel-checkin",
  getHotelDetails: "/hotel/hotel-details",
  hotelFilterResult: "/hotel/hotel-checkin",
  hotel_block: "hotel/hotel-room-block",
  hotel_book: "hotel/book",
  offersHotel: "promotion/get-offers/hotels",
  getHotelReviewTripjack: "hotel/hotel-review",
  hotelbookTripjack: "hotel/book-hotel",
  fetchHotelContentList: "seo/get-hotel-city-by-name"
};

// https://api.superbworldtrip.com/api/v1/promotion/get-offers/hotels

export const getHotelSearchList = async (searchTerm) => {
  const API_KEY = import.meta.env.VITE_SMT_V2_API_KEY;
  const headers = {
    'api-key': API_KEY
  };

  try {
    const response = await instance.get(uri.hotelCountrySearchList, {
      headers: headers,
      params: { cityName: searchTerm }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching hotel search list:', JSON.stringify(error));
    throw error;
  }
};

export const getAllHotelSearchData = async (payload) => {
  const API_KEY = import.meta.env.VITE_SMT_V2_API_KEY;
  const headers = {
    'api-key': API_KEY,
    'request-for': payload?.hotelPrice || null,
  };

  try {
    const response = await instance.post(uri.hotelCheckinCheckoutResult, payload, {
      headers: headers,
    });
    return response;
  } catch (error) {
    console.error('Error fetching hotel search data:', error);
    throw error;
  }
};

export const getHotelDetails = async (payload) => {
  const API_KEY = import.meta.env.VITE_SMT_V2_API_KEY;
  const headers = {
    'api-key': API_KEY,
  };

  try {
    const response = await instance.post(uri.getHotelDetails, payload, {
      headers: headers,
    });
    return response;
  } catch (error) {
    console.error('Error fetching hotel search data:', error);
    throw error;
  }
};


export const getAllHotelFilterData = async (reqBody, params) => {
  const API_KEY = import.meta.env.VITE_SMT_V2_API_KEY;
  const headers = {
    'api-key': API_KEY,
  };

  try {
    const response = await instance.post(uri.hotelFilterResult, reqBody, {
      headers: headers,
      params: params,
    });
    return response;
  } catch (error) {
    console.error('Error fetching hotel search data:', error);
    throw error;
  }
};


export const gethotelBlockData = async (reqBody) => {
  const API_KEY = import.meta.env.VITE_SMT_V2_API_KEY;
  const headers = {
    'api-key': API_KEY,
  };

  try {
    const response = await instance.post(uri.hotel_block, reqBody, { headers: headers, });
    return response;
  } catch (error) {
    console.error('Error fetching hotel search data:', error);
    throw error;
  }
};



export const gethotelbook = async (reqBody) => {
  const API_KEY = import.meta.env.VITE_SMT_V2_API_KEY;
  const headers = {
    'api-key': API_KEY,
  };

  try {
    const response = await instance.post(uri.hotel_book, reqBody, { headers: headers, });
    return response;
  } catch (error) {
    console.error('Error fetching hotel search data:', error);
    throw error;
  }
};


export const getHotelOffers = async () => {
  const API_KEY = import.meta.env.VITE_SMT_V2_API_KEY;
  const headers = {
    'api-key': API_KEY
  };

  try {
    const response = await instance.get(uri.offersHotel, { headers: headers, });
    return response.data;
  } catch (error) {
    console.error('Error fetching flight offers list:', error);
    throw error;
  }
};


export const fetchHotelReviewTripjack = async (payload) => {
  const API_KEY = import.meta.env.VITE_SMT_V2_API_KEY;
  const headers = {
    'api-key': API_KEY,
  };

  try {
    const response = await instance.post(uri.getHotelReviewTripjack, payload, {
      headers: headers,
    });
    return response;
  } catch (error) {
    console.error('Error fetching hotel search data:', error);
    throw error;
  }
};



export const gethotelbookTripjack = async (reqBody) => {
  const API_KEY = import.meta.env.VITE_SMT_V2_API_KEY;
  const headers = {
    'api-key': API_KEY,
  };

  try {
    const response = await instance.post(uri.hotelbookTripjack, reqBody, { headers: headers, });
    return response;
  } catch (error) {
    console.error('Error fetching hotel search data:', error);
    throw error;
  }
};

export const getHotelCityContentList = async (city) => {
  const API_KEY = import.meta.env.VITE_SMT_V2_API_KEY;
  const headers = {
    'api-key': API_KEY
  };
  try {
    const response = await instance.get(`${uri.fetchHotelContentList}/${city}`, { headers });
    return response.data;
  } catch (error) {
    console.error('Error fetching city content list:', error);
    throw error;
  }
};